import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEjecutaSQL = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'ejecuta_sql',
        name: 'Ejecuta SQL',
        component: ViewEjecutaSQL,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
